@if (SpeechRecognitionService.VoiceRecognitionAvailable()) {
<div class="ev-icon" id="voice-icon" data-testid="voice-input-toggle-btn" [ngClass]="{ 'active': IsActive() }"
  (click)="ToggleSpeechRecognition()">
  <div class="ev-icon-circle">
    <img alt="Voice Input" [src]="'assets/icons/dark/ui/voice_recording_icon.svg'"
      class="icon" />
  </div>
</div>
}